/* GG29 Garage explorer (sections/gg29-performance-garage.liquid). Station buttons swap the panel to that view's
   <template>: the new image loads and decodes first, then the old one fades out over 550 ms (instant swap for
   reduced motion). A failed load keeps the current view and shows the error message. */
(() => {
  if (customElements.get('gg29-garage')) return;
  customElements.define('gg29-garage', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController(); this.sequence = 0;
      this.panel = this.querySelector('[data-panel]'); this.status = this.querySelector('[role="status"]');
      this.querySelector('nav').hidden = false;
      this.addEventListener('click', e => { const button = e.target.closest('button[data-view]'); if (button && this.contains(button)) this.show(button.dataset.view); }, {signal:this.controller.signal});
      document.addEventListener('shopify:block:select', e => { if (this.contains(e.target)) { const button=e.target.closest('[data-view]'); if(button) this.show(button.dataset.view); } }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.sequence++; }
    async show(key) {
      const template = [...this.querySelectorAll('template[data-template]')].find(t => t.dataset.template === key);
      if (!template) return;
      const sequence = ++this.sequence; const fragment = document.importNode(template.content, true); const img = fragment.querySelector('img');
      this.status.textContent = this.dataset.loading; this.panel.setAttribute('aria-busy','true');
      try {
        if (img) { img.loading = 'eager'; await img.decode(); }
        if(sequence !== this.sequence || !this.isConnected) return;
        const previous = this.panel.querySelector('.gg29-garage__visual img')?.cloneNode(true);
        this.panel.replaceChildren(fragment);
        const visual = this.panel.querySelector('.gg29-garage__visual');
        if (previous && visual && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          previous.alt = ''; previous.setAttribute('aria-hidden', 'true');
          previous.classList.add('gg29-garage__outgoing'); visual.append(previous);
          const animation = previous.animate([{opacity:1},{opacity:0}], {duration:550,easing:'ease',fill:'forwards'});
          animation.finished.then(() => previous.remove()).catch(() => previous.remove());
        }
        this.querySelectorAll('button[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === key)));
        this.status.textContent = '';
      } catch(error) { if(sequence === this.sequence) this.status.textContent = this.dataset.error; }
      finally { if(sequence === this.sequence) this.panel.removeAttribute('aria-busy'); }
    }
  });
})();
